import { ConfigModule } from 'shared/types'
import { controls } from 'shared/components/controls'

export interface CamerasTheme {
	classLabelColor: string
	rowHeight: number
	raceNameColor: string
	timeColor: string
	bgColor: string
	height: number
	wgtPadding: number
	timeFontSize: number
	raceNameHeight: number

	wgtWidth: number
	wgtTableHeaderHeight: number
	athletePanelRowScale: number

}

import './blob'
declare module './blob' {
	interface ConfigBlob {
		camerasTheme: CamerasTheme
	}
}

export const camerasTheme: ConfigModule<CamerasTheme> = {
	page: 'cameras',
	panel: 'Theme',
	isTheme: true,
	fields: {
		classLabelColor: {
			default: 'white',
			control: controls.Color('Class Label Color')
		},
		rowHeight: {
			default: 46,
			control: controls.Number('Row Height', 10, 0.5, 1000)
		},
		raceNameColor: {
			default: 'white',
			control: controls.Color('Race Name Color')
		},
		timeColor: {
			default: 'white',
			control: controls.Color('Time Color')
		},
		bgColor: {
			default: 'black',
			control: controls.Color('Background Color')
		},
		height: {
			default: 1,
			control: controls.Number('Widget Height Scale', 0.3, 0.05, 1.0)
		},
		wgtPadding: {
			default: 0,
			control: controls.Number('Widget Padding', 0, 1, 40)
		},
		timeFontSize: {
			default: 31,
			control: controls.Number('Time Font Size', 10, 1, 100)
		},
		raceNameHeight: {
			default: 60,
			control: controls.Number('Race Name Row Height', 10, 1, 100)
		},
		wgtWidth :  {
			default: 370,
			control: controls.Number('Widget Width', 200, 1, 1000)
		},
		wgtTableHeaderHeight: {
			default: 36,
			control: controls.Number('Widget Table Header Height', 10, 1, 100)
		},
		athletePanelRowScale: {
			default: 1.8,
			control: controls.Number('Athlete Panel Row Scale', 0.1, 0.1, 2)
		}
	}
}
